import { Instance, types } from "mobx-state-tree";
import { IGuest } from "../base/Guest";
import { calendarStoreGetter } from "../utils";

export const CalendarMeeting = types
  .model("CalendarMeeting", {
    id: types.identifier,
    duration: types.number,
    start: types.number,
    roomId: types.string
  })
  .views(calendarStoreGetter)
  .views((self) => {
    const views = {
      get guest(): IGuest | undefined {
        return self.calendarStore.guestsByRoom.get(self.roomId);
      },
      get guestDisplayName(): string {
        return (views.guest && views.guest.displayedName) || "Unknown";
      }
    };
    return views;
  });

export type ICalendarMeeting = Instance<typeof CalendarMeeting>;
